import { createSelector } from "reselect";

const reviewSelector = (state) => state.review;

export const selectSelectedReviews = createSelector(
    reviewSelector,
    (state) => state?.selectedReviews
)